import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoTreatmentInfoFilter} from "./models/DtoTreatmentInfoFilter";
import {DtoTreatmentInfoBaseItems} from "./models/DtoTreatmentInfoBaseItems";
import {DtoTreatmentInfo} from "./models/DtoTreatmentInfo";

@Injectable()
export class TreatmentInfoService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'management'
    }

    public getTreatmentInfo = (filter: DtoTreatmentInfoFilter): Observable<DtoTreatmentInfo> => {
        return this.http.post<DtoTreatmentInfo>(`${this.apiUrl}/treatmentinfo/`, filter);
    };

    public getTreatmentInfoBaseItems = (): Observable<DtoTreatmentInfoBaseItems> => {
        return this.http.get<DtoTreatmentInfoBaseItems>(`${this.apiUrl}/treatmentinfo/baseitems`);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/treatment-info/treatment-info.service.ts